<footer>
  <div class="tblRow mb-15">
    <div class="linksCombined">
      <div class="social-buttons hidden-print">
        <a class="social-button twitter" href="https://twitter.com/chubb_seguros" data-social-bookmark="Twitter"
          target="_blank" title="Twitter - Open in new window" data-tracked="true" rel="noopener">
          <span class="sr-only">Twitter</span>
        </a>
        <a class="social-button linkedin" href="https://www.linkedin.com/company/chubb" data-social-bookmark="LinkedIn"
          target="_blank" title="LinkedIn - Open in new window" data-tracked="true" rel="noopener">
          <span class="sr-only">LinkedIn</span>
        </a>
        <a class="social-button youtube" href="https://www.youtube.com/user/ChubbInsurance"
          data-social-bookmark="YouTube" target="_blank" title="YouTube - Open in new window" data-tracked="true"
          rel="noopener">
          <span class="sr-only">YouTube</span>
        </a>
        <a class="social-button instagram" href="https://www.instagram.com/chubbglobal/"
          data-social-bookmark="Instagram" target="_blank" title="Instagram - Open in new window" data-tracked="true"
          rel="noopener">
          <span class="sr-only">Instagram</span>
        </a>
      </div>
    </div>
  </div>
  <div class="tblRow display-block">
    <div class="copyright">© {{year}} Chubb</div>
    <div class="links">
      <ul class="list-unstyled">
        <li><a href="https://www.chubb.com/ar-es/politica-de-privacidad.aspx"
            title="Política de privacidad - Open in new window" target="_blank" rel="noopener">Política de
            privacidad</a></li>
        <li><a href="https://www.chubb.com/_global-assets/documents/licensinginformation.pdf"
            title="Información sobre licencias" target="_blank" rel="noopener">Información sobre licencias</a></li>
      </ul>
    </div>
  </div>
  <div class="footer-text">
    <a href="https://www.argentina.gob.ar/superintendencia-de-seguros" target="_blank" rel="noopener">
      <img src="assets/img/chubb_footer_SSN_oscuro.png" class="footer-img" alt="footer SSN image">
    </a>
  </div>
</footer>